import React, { useState, useEffect } from "react";
import TabsComponent from "../tabswitches";
import refreshicon from "../../../../assets/patientcharts/ic-replay-24px.svg";

const LabsHeader = ({ years, selectedYear, setSelectedYear, refreshLabData }) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [isClicked, setIsClicked] = useState(false);

  // sync tab when parent changes year
  useEffect(() => {
    if (years.length > 0) {
      const index = years.indexOf(selectedYear);
      if (index !== -1) setSelectedTab(index);
    }
  }, [years, selectedYear]);

  const handleTabClick = (index) => {
    setSelectedTab(index);
    setSelectedYear(years[index]); // ONLY here
  };

  const handleRefreshClick = () => {
    setIsClicked(true);
    refreshLabData();
    setTimeout(() => setIsClicked(false), 500);
  };

  return (
    <div className="flex justify-between items-center mb-4">
      <div className="w-1/3">
        <TabsComponent
          tabs={years.map((y) => ({ label: y, width: 44 }))}
          selectedTab={selectedTab}
          onSelectTab={handleTabClick}
        />
      </div>

      <div className="flex items-center space-x-4 mr-6">
        <div
          className={`flex items-center space-x-2 p-1 cursor-pointer ${
            isClicked ? "border bg-gray-200 rounded" : ""
          }`}
          onClick={handleRefreshClick}
        >
          <img src={refreshicon} alt="Refresh Icon" />
          <div style={{ fontSize: "14px" }} className="text-[#50869A]">
            REFRESH
          </div>
        </div>
      </div>
    </div>
  );
};


export default LabsHeader;
